import { render, staticRenderFns } from "./ReceiveUpdate.vue?vue&type=template&id=598babc2&"
import script from "./ReceiveUpdate.vue?vue&type=script&lang=js&"
export * from "./ReceiveUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports